import React, { useState } from "react";
import styled from "styled-components";
import AddFtpUser from "../addFtpUser";
import DeleteFtpUser from "../removeFtpUser";

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BaseBtn = styled.button`
  height: 36px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #fff;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s, opacity 0.15s, background 0.15s;

  &:hover {
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

const CreateBtn = styled(BaseBtn)`
  background: #2563eb;
  &:hover {
    background: #1d4ed8;
  }
`;

const DeleteBtn = styled(BaseBtn)`
  background: #ef4444; /* red-500 */
  &:hover {
    background: #dc2626; /* red-600 */
  }
`;

const Header = () => {
  const [isCreate, setIsCreate] = useState(false);
  const [isDelete, setIsDelete] = useState(false); // ✅ 초기값 false

  return (
    <Wrap>
      {isCreate && <AddFtpUser open={isCreate} setOpen={setIsCreate} />}
      {isDelete && <DeleteFtpUser open={isDelete} setOpen={setIsDelete} />}

      <CreateBtn onClick={() => setIsCreate(true)} aria-label="Add FTP user">
        Add User
      </CreateBtn>
      <DeleteBtn onClick={() => setIsDelete(true)} aria-label="Delete FTP user">
        Delete User
      </DeleteBtn>
    </Wrap>
  );
};

export default Header;
